import { render, staticRenderFns } from "./VekaletForm.vue?vue&type=template&id=74d16c3d&scoped=true"
import script from "./VekaletForm.vue?vue&type=script&lang=ts"
export * from "./VekaletForm.vue?vue&type=script&lang=ts"
import style0 from "./VekaletForm.vue?vue&type=style&index=0&id=74d16c3d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d16c3d",
  null
  
)

export default component.exports